import React, { Component } from 'react';
import { connect } from 'react-redux';
import { importPOCannabisTemplate } from 'actions/EntityActions';
import ConfirmPODialog from './ConfirmPODialog';
import DialogInput from '../advanced/DialogInput';
import Button from './Button';
import moment from 'moment';
import { showError } from 'actions/CommonActions';
import { readExcel } from 'utils/helpers';
import DialogHeaderWithClose from './DialogHeaderWithClose';
class ExcelUploadCannabisPO extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openDialog: false,
            confirmDialog: false,
            totalPriceMatch: false,
            POName: '',
            model: {}
        };
    }
 
    callback = (model) => {
        let subtotal = 0;
        model.Products.map(item => { subtotal += item.Quantity * item.UnitPrice; });
        const today = new Date();
        this.props.purchaseOrderList.map(item => { if (item.subTotal != 0 && item.subTotal - subtotal < 0.2 && item.subTotal - subtotal > -0.2 && moment(today).diff(moment(item.creationDate), 'days') < 4) this.setState({ totalPriceMatch: true, POName: item.description }) });
        this.setState({ model });

        let thccbdinPO = false;
        for (let j = 0; j < model.Products.length; j++) {
            if (model.Products[j].thc > 0 || model.Products[j].cbd > 0) {
                thccbdinPO = true;
                break;
            }
        }
        if (!this.props.receivePurchaseOrderWhenCreate && thccbdinPO) {
            this.setState({ openDialog: true })
        }
        else {
            this.setState({ confirmDialog: true })
        }
    }

    uploadFile = (e, callback) => {
        e.preventDefault();
        let BranchId = this.props.branchId;
        readExcel(e.target.files[0]).then((data) => {
            try {
                let productArray = [];
                if (data.length > 0) {
                    if (data[0]["SKU"] != "TECHPOS PO IMPORT CANNABIS TEMPLATE") {
                        this.props.showError("Wrong template used! Please download the latest version of template and try again!");
                        return;
                    }
                    //shipping fee
                    const ShippingCost = data[2]["TotalQuantity"] ? Number(data[2]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //recycle fee
                    const RecycleFee = data[2]["UnitSalesPrice(Optional)"] ? Number(data[2]["UnitSalesPrice(Optional)"].toString().replace('$', '')) : 0;
                    //Credits
                    const Credits = data[3]["UnitSalesPrice(Optional)"] ? Number(data[3]["UnitSalesPrice(Optional)"].toString().replace('$', '')) : 0;
                    //vendor name
                    const VendorName = data[3]["TotalQuantity"];

                    if ((!VendorName)) {
                        this.props.showError("VendorName can't be empty!");
                        return;
                    }

                    //invoice name
                    const InvoiceName = data[4]["TotalQuantity"];
                    //pst
                    const PST = data[5]["TotalQuantity"] ? Number(data[5]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //gst
                    const GST = data[6]["TotalQuantity"] ? Number(data[6]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //hst
                    const HST = data[7]["TotalQuantity"] ? Number(data[7]["TotalQuantity"].toString().replace('$', '')) : 0;
                    
                    for (let i = 9; i < data.length; i++) {
                        const SKU = data[i]["SKU"];
                        const quantity = +data[i]["TotalQuantity"];
                        const unitPrice = data[i]["UnitCostPrice"] ? data[i]["UnitCostPrice"].toString().replace('$', '') : '';
                        const SalesPrice = data[i]["UnitSalesPrice(Optional)"] ? data[i]["UnitSalesPrice(Optional)"].toString().replace('$', '') : '';
                        const lotNumber = data[i]["LotNumber"] ? data[i]["LotNumber"] : null;
                        const UPC = data[i]["UPC"] ? data[i]["UPC"] : null;
                        const thc = data[i]["THC_Value _%(Optional)"] ? data[i]["THC_Value _%(Optional)"] : null;
                        const cbd = data[i]["CBD_value_%(Optional)"] ? data[i]["CBD_value_%(Optional)"] : null;
                        const ProductName = data[i]["ProductName(Optional)"];
                        const CategoryName = data[i]["CategoryName(Optional)"];
                        const DFE = data[i]["DFE(Optional)"];
                        const Location = data[i]["Location(Optional)"];

                        if ((!SKU)) {
                            this.props.showError("SKU can't be empty! Please check line " + (i + 5));
                            return;
                        }

                        if (SKU.length >= 50) {
                            this.props.showError("SKU length can't be over 50 characters! Please check line " + (i + 5));
                            return;                           
                        }
                        if ((isNaN(quantity) || Number(quantity) <= 0) || (isNaN(unitPrice) || Number(unitPrice) <= 0)) {
                            this.props.showError(`Format issue detected for SKU:${SKU}. Please make sure no comma exists and trim all the cells in the file imported.`);
                            return;
                        }

                        const checkNumberObj = {
                            "TotalQuantity": quantity,
                            "THC_Value _%(Optional)": thc, 
                            "CBD_value_%(Optional)": cbd, 
                            "DFE(Optional)": DFE
                        }
                        const resultArr = Object.keys(checkNumberObj).filter((item) => checkNumberObj[item] && typeof checkNumberObj[item] !== "number");
                        const numberText = resultArr.join(", ");

                        if (resultArr.length > 0){
                            this.props.showError(`Please make sure the following field(s): ${numberText} should be Number`);
                            return;
                        }

                        const model = {
                            SKU,
                            Quantity: Number(quantity),
                            UnitPrice: Number(unitPrice),
                            SalesPrice: Number(SalesPrice),
                            UPC,
                            ProductName,
                            CategoryName,
                            lotNumber: lotNumber,
                            thc: Number(thc),
                            cbd: Number(cbd),
                            DFE: Number(DFE),
                            Location
                        };

                        productArray.push(model);
                    }

                    const model = {
                        BranchId,
                        VendorName,
                        ShippingCost,
                        PST,
                        GST,
                        HST,
                        RecycleFee,
                        Credits,
                        InvoiceName,
                        Products: productArray
                    }

                    callback(model);
                } else {
                    this.props.showError("No data found in PO file, please make sure you upload the PO file with excel format.");
                    return;
                }
            } catch (error) {
                console.log(error);
                this.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
                return;
            }
        });
    }

    closeCheckDialog = () => {
        this.setState({ openDialog: false });
    }

    openConfirmDialog = () => {
        this.closeCheckDialog();
        this.setState({ confirmDialog: true });
    }

    closeConfirmDialog = () => {
        this.setState({ confirmDialog: false });
        this.setState({ totalPriceMatch: false, POName: "", model: [] });
    }

    createPO = () => {
        this.props.importPOCannabisTemplate(this.state.model);
        this.closeConfirmDialog();
    }

    render() {
        const styles = {
            uploadButton: this.props.buttonStyles,
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: '2px',
                left: 0,
                width: '100%',
                opacity: 0
            }
        };
        return (
            <span>
                <Button
                    label="Import FROM CANNABIS TEMPLATE"
                    labelPosition="before"
                    containerElement="label"
                    style={styles.uploadButton}
                    primary={true}
                    className="btnNewBrandPOS"
                    id="importFromCannabisTemplate"
                >
                    <input className="fileInput"
                        type="file"
                        id="inputimportFromCannabisTemplate"
                        style={styles.uploadInput}
                        onChange={(e) => this.uploadFile(e, this.callback)}
                        onClick={(e) => e.target.value = null} />
                    <DialogInput
                        title={<DialogHeaderWithClose text="Proceed With Purchase Order Create" classicClass="posDialogClassic" handleClose={() => this.closeCheckDialog()} />}
                        actions={[
                            <Button
                                key={1}
                                type="CancelButton"
                                name="buttonCancel"
                                className="btn-space"
                                label="Cancel"
                                onTouchTap={() => this.closeCheckDialog()} />,
                            <Button
                                key={2}
                                name="ConfirmButton"
                                label="Proceed"
                                primary={true}
                                onTouchTap={() => this.openConfirmDialog()} />]}
                        modal={true}
                        open={this.state.openDialog}>
                        <h3>Purchase Order Auto Receive is set to off</h3>
                        <h4>THC/CBD Levels in PO Template will not be recorded, Do you want to proceed?</h4>
                    </DialogInput>
                    <ConfirmPODialog
                        branchName={this.props.branchName}
                        totalPriceMatch={this.state.totalPriceMatch}
                        POName={this.state.POName}
                        model={this.state.model}
                        confirmDialog={this.state.confirmDialog}
                        closeDialog={this.closeConfirmDialog}
                        createPO={this.createPO} />
                </Button>
            </span>
        );
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        province: state.common.store.provinceState,
        receivePurchaseOrderWhenCreate: state.common.applicationSettings.receivePurchaseOrderWhenCreate,
        branchName: state.common.store.name || '',
        purchaseOrderList: state.entity.purchaseOrderList || []
    };
}

function mapDispatchToProps(dispatch) {
    return {
        importPOCannabisTemplate: (model) => dispatch(importPOCannabisTemplate(model)),
        showError: (message) => dispatch(showError(message))
    }
}

export default connect(mapStatetoProps, mapDispatchToProps)(ExcelUploadCannabisPO);